import type { RouteRecordRaw } from 'vue-router';
import { SettingMenu } from '@/modules/settings/domain/policies';
import { guard } from '@/common/router/public';
import { NavigationRoute } from './NavigationRoute';

export const settings: RouteRecordRaw[] = [
  {
    path: 'templates',
    name: NavigationRoute.MessageTemplates,
    beforeEnter: guard().hasAuthorization(SettingMenu.AccessMessageTemplates),
    component: () =>
      import(/* webpackChunkName: "settings" */ '../../ui/pages/MessageTemplates.vue'),
  },
  {
    path: 'voice-messages',
    name: NavigationRoute.VoiceMessages,
    component: () =>
      import(
        /* webpackChunkName: "settings" */ '../../../settings-calls-management/ui/pages/VoiceMessages.vue'
      ),
  },
  {
    path: 'traffic-control',
    name: NavigationRoute.TrafficControl,
    beforeEnter: guard().hasAuthorization(SettingMenu.AccessTrafficControl),
    component: () => import(/* webpackChunkName: "settings" */ '../../ui/pages/TrafficControl.vue'),
  },
];
